import { render, staticRenderFns } from "./DisplayX19229.vue?vue&type=template&id=172727b0&"
import script from "./DisplayX19229.vue?vue&type=script&lang=js&"
export * from "./DisplayX19229.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports